import axios from 'axios'

class UserFactory {
  async students (data: any) {
    try {
      const url = '/student/search'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }
}

export const userFactory = new UserFactory()
